import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {HeaderComponent} from "./header/header";
import {AnalyticsService} from "./core/services/analytics.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [
        RouterOutlet,
        HeaderComponent
    ],
    standalone: true,
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(analytics: AnalyticsService) {
    analytics.init();
  }

  title = 'Imaš Termin';
}
